const translations = {
  en: {
    // Meta
    "meta.title": "Reveal Ad — Find Who's Running Google Ads",
    "meta.description": "Reveal which prospects are spending money on Google Ads. Upload your domain list and get instant results.",

    // Header / Footer
    "header.brand": "Reveal Ad",
    "footer.powered": "Powered by Swiss Product Studio",

    // Hero
    "hero.title.line1": "Reveal Which Prospects Are",
    "hero.title.line2": "Spending Money On Ads.",
    "hero.title.line3": "Pitch The Right Ones.",
    "hero.subtitle": "Stop pitching blind. Upload your domain list and instantly reveal who is running Google Ads campaigns. Qualify your prospects, then unlock the verified emails to reach them.",
    "hero.microcopy": "Instant Report \u00b7 No Login Required \u00b7 Powered by best data",

    // File Uploader
    "upload.stepTitle": "Upload Your File",
    "upload.dropzone": "Drop your file here or click to browse",
    "upload.formats": "CSV or Excel \u00b7 Max 5,000 domains",
    "upload.parsing": "Parsing file...",
    "upload.domainsFound": "{count} domains found",
    "upload.remove": "Remove",

    // Domain Preview
    "preview.title": "Domain Preview",
    "preview.tableHeader": "Domain",
    "preview.domainsReady": "{count} domains ready for analysis",
    "preview.emptyTitle": "Upload a file to preview domains",
    "preview.emptySubtitle": "Supports CSV and Excel files",

    // Search Config
    "config.stepTitle": "Configure Search",
    "config.countryLabel": "Country",
    "config.formatLabel": "Ad Format",

    // Checkout Buttons
    "checkout.adButton": "Reveal Ads \u2014 {price} CHF",
    "checkout.fullButton": "Full Reveal \u2014 {price} CHF",
    "checkout.redirecting": "Redirecting to payment...",
    "checkout.contactSales": "Contact Sales",

    // How It Works
    "howItWorks.title": "How It Works",
    "howItWorks.step1.title": "Upload",
    "howItWorks.step1.desc": "Drop your list of domains (Excel/CSV).",
    "howItWorks.step2.title": "Reveal",
    "howItWorks.step2.desc": "We scan live data to find information.",
    "howItWorks.step3.title": "Pitch",
    "howItWorks.step3.desc": "We deliver Excel file with results to your inbox.",

    // Pricing
    "pricing.title.before": "Simple",
    "pricing.title.highlight": "\"Pay-as-you-Go\"",
    "pricing.title.after": "Pricing",
    "pricing.tab.ad": "Ad Reveal",
    "pricing.tab.full": "Full Reveal",
    "pricing.bestValue": "BEST VALUE",
    "pricing.perUpload": "per upload",
    "pricing.totalPrice": "Total price:",
    "pricing.domains": "{count} domains",
    "pricing.domainsUpTo": "Up to {count} domains",
    "pricing.includes": "INCLUDES:",
    "pricing.cta": "Get Started",
    "pricing.contactSales": "Need more than 5,000 domains? Contact sales.",
    "pricing.ad.name": "Ad Reveal",
    "pricing.ad.subtitle": "For agencies who just need the data.",
    "pricing.ad.feature1": "Bulk Ad Status (Active/Inactive)",
    "pricing.ad.feature2": "Ad Creative Count & Formats",
    "pricing.ad.feature3": "Direct Links to Live Ads",
    "pricing.ad.noEmail": "No Email Contacts",
    "pricing.ad.button": "Get Ad Reveal",
    "pricing.full.badge": "BEST VALUE",
    "pricing.full.name": "Full Reveal",
    "pricing.full.subtitle": "For sales teams who need to close.",
    "pricing.full.feature1": "Everything in Ad Reveal",
    "pricing.full.feature2": "Verified Email Addresses",
    "pricing.full.feature3": "Deliverability Validation",
    "pricing.full.feature4": "Bonus: Airtable \"Sales CRM\" Template",
    "pricing.full.feature5": "LinkedIn Profile URL",
    "pricing.full.button": "Get Full Reveal",

    // Thank You
    "thankyou.title": "Thank you!",
    "thankyou.message": "We are collecting data about ads, once completed you will receive results in your email.",
    "thankyou.contact": "If you have any questions, write to us at",
    "thankyou.button": "Analyze More Domains",

    // Toasts
    "toast.paymentCancelled": "Payment was cancelled",
    "toast.uploadFirst": "Please upload a file first",
    "toast.checkoutFailed": "Failed to create checkout",
    "toast.uploadFailed": "Failed to upload file",
    "toast.invalidFile": "Please upload a CSV or Excel file",
    "toast.domainsFound": "Found {count} domains",

    // Dropdown options
    "formats.all": "All Formats",
    "formats.text": "Text Ads",
    "formats.image": "Image Ads",
    "formats.video": "Video Ads",

    // Anti-Friction Bar
    "friction.noRetainers": "No Monthly Retainers",
    "friction.noRetainersDesc": "Why pay for a month when you only need data today?",
    "friction.noRegistration": "No Registration",
    "friction.noRegistrationDesc": "Get your report sent straight to your inbox.",
    "friction.verifiedData": "100% Verified Data",
    "friction.verifiedDataDesc": "Real ad spend signals. Real contact info.",

    // Value Stack
    "value.title.before": "The Fastest Way to",
    "value.title.highlight": "Qualify a Lead List",
    "value.signal.title": "The Signal (Ad Reveal)",
    "value.signal.subtitle": "Validate The Budget",
    "value.signal.desc": "Don\u2019t waste time on the wrong companies. We reveal exactly which domains are active on Google Ads right now.",
    "value.signal.feature1.title": "Proof of Budget",
    "value.signal.feature1.desc": "See if they are currently spending money.",
    "value.signal.feature2.title": "Analyze Their Strategy",
    "value.signal.feature2.desc": "See their ad copy, formats, and landing pages.",
    "value.signal.feature3.title": "Spot Weaknesses",
    "value.signal.feature3.desc": "Find bad ads so you can pitch a better solution.",
    "value.outreach.title": "The Outreach (Full Reveal)",
    "value.outreach.subtitle": "Reach The Decision Maker",
    "value.outreach.desc": "Knowing if they have ads or not is half the battle. Reaching the person who signs the check is the rest.",
    "value.outreach.feature1.title": "Verified Emails",
    "value.outreach.feature1.desc": "We enrich your domain list with valid contact info.",
    "value.outreach.feature2.title": "Marketing Focus",
    "value.outreach.feature2.desc": "We prioritize finding marketing directors and founders.",
    "value.outreach.feature3.title": "Ready-to-Pitch",
    "value.outreach.feature3.desc": "You get a clean CSV/Excel file ready for your cold email tool.",

    // Airtable Template
    "airtable.badge": "BONUS",
    "airtable.title": "Sales CRM Template",
    "airtable.desc": "Get a ready-to-use Airtable template designed specifically for managing your ad-qualified leads. Track outreach, follow-ups, and conversions in one place.",
    "airtable.feature1": "Pre-built lead pipeline views",
    "airtable.feature2": "Outreach tracking & follow-up reminders",
    "airtable.feature3": "Included free with Full Reveal",
    "airtable.videoSoon": "Video walkthrough coming soon",

    // No List Section
    "noList.title": "Don\u2019t have a prospect list yet?",
    "noList.desc": "Tell us your niche (e.g., \"Dentists in Zurich\" or \"SaaS in Berlin\") and we will generate a fresh domain list for you.",
    "noList.button": "Generate for 9 CHF",

    // FAQ
    "faq.title": "Frequently Asked Questions",
    "faq.q1": "How do I get my results if I don't create an account?",
    "faq.a1": "Simple. After payment, we process your file and email the Excel file with results to your inbox. This usually takes less than 5 minutes.",
    "faq.q2": "Where does the email data come from?",
    "faq.a2": "We use top-tier providers to ensure high deliverability. We don't just scrape; we verify.",
    "faq.q3": "What if a domain has no ads?",
    "faq.a3": "That's valuable data too! It means they are an open opportunity for you to pitch your ad services.",
  },

  de: {
    // Meta
    "meta.title": "Reveal Ad \u2014 Finden Sie heraus, wer Google Ads schaltet",
    "meta.description": "Finden Sie heraus, welche Prospects Geld f\u00fcr Google Ads ausgeben. Domain-Liste hochladen und sofort Resultate erhalten.",

    // Header / Footer
    "header.brand": "Reveal Ad",
    "footer.powered": "Powered by Swiss Product Studio",

    // Hero
    "hero.title.line1": "Finden Sie heraus,",
    "hero.title.line2": "welche Prospects Geld f\u00fcr Ads ausgeben.",
    "hero.title.line3": "Pitchen Sie die Richtigen.",
    "hero.subtitle": "Schluss mit Blindfl\u00fcgen. Laden Sie Ihre Domain-Liste hoch und sehen Sie sofort, wer Google Ads schaltet. Qualifizieren Sie Ihre Prospects und erhalten Sie verifizierte E-Mails.",
    "hero.microcopy": "Sofort-Bericht \u00b7 Kein Login n\u00f6tig \u00b7 Powered by best data",

    // File Uploader
    "upload.stepTitle": "Datei hochladen",
    "upload.dropzone": "Datei hier ablegen oder zum Durchsuchen klicken",
    "upload.formats": "CSV oder Excel \u00b7 Max. 5.000 Domains",
    "upload.parsing": "Datei wird verarbeitet...",
    "upload.domainsFound": "{count} Domains gefunden",
    "upload.remove": "Entfernen",

    // Domain Preview
    "preview.title": "Domain-Vorschau",
    "preview.tableHeader": "Domain",
    "preview.domainsReady": "{count} Domains bereit zur Analyse",
    "preview.emptyTitle": "Datei hochladen f\u00fcr Domain-Vorschau",
    "preview.emptySubtitle": "Unterst\u00fctzt CSV- und Excel-Dateien",

    // Search Config
    "config.stepTitle": "Suche konfigurieren",
    "config.countryLabel": "Land",
    "config.formatLabel": "Ad-Format",

    // Checkout Buttons
    "checkout.adButton": "Ads aufdecken \u2014 {price} CHF",
    "checkout.fullButton": "Full Reveal \u2014 {price} CHF",
    "checkout.redirecting": "Weiterleitung zur Zahlung...",
    "checkout.contactSales": "Sales kontaktieren",

    // How It Works
    "howItWorks.title": "So funktioniert's",
    "howItWorks.step1.title": "Hochladen",
    "howItWorks.step1.desc": "Domain-Liste hochladen (Excel/CSV).",
    "howItWorks.step2.title": "Aufdecken",
    "howItWorks.step2.desc": "Wir scannen Live-Daten, um Informationen zu finden.",
    "howItWorks.step3.title": "Pitchen",
    "howItWorks.step3.desc": "Wir senden die Excel-Datei mit den Resultaten an Ihre Inbox.",

    // Pricing
    "pricing.title.before": "Einfaches",
    "pricing.title.highlight": "\"Pay-as-you-Go\"",
    "pricing.title.after": "Pricing",
    "pricing.tab.ad": "Ad Reveal",
    "pricing.tab.full": "Full Reveal",
    "pricing.bestValue": "BEST VALUE",
    "pricing.perUpload": "pro Upload",
    "pricing.totalPrice": "Gesamtpreis:",
    "pricing.domains": "{count} Domains",
    "pricing.domainsUpTo": "Bis zu {count} Domains",
    "pricing.includes": "ENTHÄLT:",
    "pricing.cta": "Jetzt starten",
    "pricing.contactSales": "Mehr als 5.000 Domains? Sales kontaktieren.",
    "pricing.ad.name": "Ad Reveal",
    "pricing.ad.subtitle": "F\u00fcr Agenturen, die nur die Daten ben\u00f6tigen.",
    "pricing.ad.feature1": "Bulk Ad-Status (Aktiv/Inaktiv)",
    "pricing.ad.feature2": "Anzahl Ad Creatives & Formate",
    "pricing.ad.feature3": "Direkte Links zu Live-Ads",
    "pricing.ad.noEmail": "Keine E-Mail-Kontakte",
    "pricing.ad.button": "Ad Reveal holen",
    "pricing.full.badge": "BEST VALUE",
    "pricing.full.name": "Full Reveal",
    "pricing.full.subtitle": "F\u00fcr Sales-Teams, die Abschl\u00fcsse wollen.",
    "pricing.full.feature1": "Alles aus Ad Reveal",
    "pricing.full.feature2": "Verifizierte E-Mail-Adressen",
    "pricing.full.feature3": "Zustellbarkeits-Pr\u00fcfung",
    "pricing.full.feature4": "Bonus: Airtable \u00abSales CRM\u00bb Template",
    "pricing.full.feature5": "LinkedIn-Profil-URL",
    "pricing.full.button": "Full Reveal holen",

    // Thank You
    "thankyou.title": "Vielen Dank!",
    "thankyou.message": "Wir sammeln die Ad-Daten. Sobald wir fertig sind, erhalten Sie die Resultate per E-Mail.",
    "thankyou.contact": "Bei Fragen schreiben Sie uns einfach an",
    "thankyou.button": "Weitere Domains analysieren",

    // Toasts
    "toast.paymentCancelled": "Zahlung wurde abgebrochen",
    "toast.uploadFirst": "Bitte zuerst eine Datei hochladen",
    "toast.checkoutFailed": "Checkout konnte nicht erstellt werden",
    "toast.uploadFailed": "Upload fehlgeschlagen",
    "toast.invalidFile": "Bitte laden Sie eine CSV- oder Excel-Datei hoch",
    "toast.domainsFound": "{count} Domains gefunden",

    // Dropdown options
    "formats.all": "Alle Formate",
    "formats.text": "Text-Ads",
    "formats.image": "Image-Ads",
    "formats.video": "Video-Ads",

    // Anti-Friction Bar
    "friction.noRetainers": "Keine monatlichen Kosten",
    "friction.noRetainersDesc": "Warum monatlich zahlen, wenn Sie die Daten nur heute brauchen?",
    "friction.noRegistration": "Keine Registrierung",
    "friction.noRegistrationDesc": "Der Bericht wird direkt an Ihre Inbox gesendet.",
    "friction.verifiedData": "100% verifizierte Daten",
    "friction.verifiedDataDesc": "Echte Ad-Spend-Signale. Echte Kontaktdaten.",

    // Value Stack
    "value.title.before": "Der schnellste Weg,",
    "value.title.highlight": "eine Lead-Liste zu qualifizieren",
    "value.signal.title": "Das Signal (Ad Reveal)",
    "value.signal.subtitle": "Budget validieren",
    "value.signal.desc": "Verschwenden Sie keine Zeit mit den falschen Unternehmen. Wir zeigen Ihnen genau, welche Domains gerade auf Google Ads aktiv sind.",
    "value.signal.feature1.title": "Budget-Nachweis",
    "value.signal.feature1.desc": "Sehen Sie, ob sie aktuell Geld ausgeben.",
    "value.signal.feature2.title": "Strategie analysieren",
    "value.signal.feature2.desc": "Sehen Sie Ad-Texte, Formate und Landingpages.",
    "value.signal.feature3.title": "Schw\u00e4chen erkennen",
    "value.signal.feature3.desc": "Finden Sie schlechte Ads und pitchen Sie eine bessere L\u00f6sung.",
    "value.outreach.title": "Der Outreach (Full Reveal)",
    "value.outreach.subtitle": "Entscheider erreichen",
    "value.outreach.desc": "Zu wissen, ob sie Ads schalten, ist die halbe Miete. Die Person zu erreichen, die unterschreibt, ist der Rest.",
    "value.outreach.feature1.title": "Verifizierte E-Mails",
    "value.outreach.feature1.desc": "Wir reichern Ihre Domain-Liste mit validen Kontaktdaten an.",
    "value.outreach.feature2.title": "Marketing-Fokus",
    "value.outreach.feature2.desc": "Wir priorisieren Marketing-Leiter und Gr\u00fcnder.",
    "value.outreach.feature3.title": "Pitch-bereit",
    "value.outreach.feature3.desc": "Sie erhalten eine saubere CSV/Excel-Datei f\u00fcr Ihr Cold-E-Mail-Tool.",

    // Airtable Template
    "airtable.badge": "BONUS",
    "airtable.title": "Sales-CRM-Template",
    "airtable.desc": "Erhalten Sie ein Airtable-Template, das speziell f\u00fcr die Verwaltung Ihrer ad-qualifizierten Leads entwickelt wurde. Outreach, Follow-ups und Conversions an einem Ort.",
    "airtable.feature1": "Vorgefertigte Lead-Pipeline-Ansichten",
    "airtable.feature2": "Outreach-Tracking & Follow-up-Erinnerungen",
    "airtable.feature3": "Gratis im Full Reveal enthalten",
    "airtable.videoSoon": "Video-Anleitung kommt bald",

    // No List Section
    "noList.title": "Noch keine Prospect-Liste?",
    "noList.desc": "Nennen Sie uns Ihre Nische (z.\u00a0B. \u00abZahn\u00e4rzte in Z\u00fcrich\u00bb oder \u00abSaaS in Berlin\u00bb) und wir erstellen eine frische Domain-Liste f\u00fcr Sie.",
    "noList.button": "Generieren f\u00fcr 9 CHF",

    // FAQ
    "faq.title": "H\u00e4ufig gestellte Fragen",
    "faq.q1": "Wie erhalte ich meine Resultate ohne Konto?",
    "faq.a1": "Ganz einfach. Nach der Zahlung verarbeiten wir Ihre Datei und senden die Excel-Datei mit den Resultaten an Ihre Inbox. Das dauert in der Regel weniger als 5 Minuten.",
    "faq.q2": "Woher stammen die E-Mail-Daten?",
    "faq.a2": "Wir nutzen erstklassige Anbieter f\u00fcr hohe Zustellbarkeit. Wir scrapen nicht einfach \u2013 wir verifizieren.",
    "faq.q3": "Was, wenn eine Domain keine Ads hat?",
    "faq.a3": "Auch das sind wertvolle Daten! Es bedeutet, dass hier eine offene Gelegenheit f\u00fcr Sie besteht, Ihre Ad-Services zu pitchen.",
  },
};

export default translations;
